import { render, staticRenderFns } from "./PropertySelectMultiple.vue?vue&type=template&id=48f6a556"
import script from "./PropertySelectMultiple.vue?vue&type=script&lang=js"
export * from "./PropertySelectMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports